import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgPhone = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.164 16-16S24.837 0 16 0"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.18 18.143a2 2 0 0 0 2.308.374l.25-.125a2 2 0 0 1 2.308.375l2.652 2.651a.5.5 0 0 1-.196.828l-2.414.805c-1.95.65-4.1.143-5.554-1.311l-5.999-5.999a4.39 4.39 0 0 1-.822-5.064l1.104-2.208a.5.5 0 0 1 .801-.13l2.733 2.733a2 2 0 0 1 .374 2.308l-.124.25a2 2 0 0 0 .374 2.309z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgPhone);

export default ForwardRef;
